import { render, staticRenderFns } from "./ConfTypeTile.vue?vue&type=template&id=44aaa53e&scoped=true&"
import script from "./ConfTypeTile.vue?vue&type=script&lang=js&"
export * from "./ConfTypeTile.vue?vue&type=script&lang=js&"
import style0 from "./ConfTypeTile.vue?vue&type=style&index=0&id=44aaa53e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44aaa53e",
  null
  
)

export default component.exports